// extracted by mini-css-extract-plugin
module.exports = {"loader":"history_loader__WRmot","content":"history_content__2hUbE","title-bar":"history_title-bar__1pkJC","empty":"history_empty__1dkqc"};